export default "__VITE_ASSET__DhoJEz5h__"